// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/index.css */
body {
  background: linear-gradient(135deg, #4a00e0, #8e2de2);
  margin: 0;
  font-family: 'Arial', sans-serif;
  display: block;
}

#root {
  display: flex;
  justify-content: center;
  align-items: start;
  height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB;EACE,qDAAqD;EACrD,SAAS;EACT,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,aAAa;AACf","sourcesContent":["/* src/index.css */\nbody {\n  background: linear-gradient(135deg, #4a00e0, #8e2de2);\n  margin: 0;\n  font-family: 'Arial', sans-serif;\n  display: block;\n}\n\n#root {\n  display: flex;\n  justify-content: center;\n  align-items: start;\n  height: 100vh;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
